




















































import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class StepSlider extends Vue {
    @Prop() steps!: Step[];

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
        controls: HTMLElement;
    };

    slider: any = null;

    private mounted() {
        this.initSlider();
    }

    private initSlider() {
        this.$nextTick(() => {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1.2,
                gutter: 16,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: true,
                controlsContainer: this.$refs.controls,
                nav: false,
                swipeAngle: false,
                responsive: {
                    1024: {
                        items: 3.04,
                        gutter: 24
                    }
                }
            });
        });
    }
}
